module.exports = __webpack_public_path__ + "img/all.843c1b62.png";